import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  SP_CLIENT_ID_DEV,
  SP_CLIENT_ID_STAGE,
  SP_CLIENT_ID_LIVE,
} from "../../../utils/constants";
import { useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { getClientIdFromUrl } from "../../../utils/commonLogics";

const CreateSurveyFrame = () => {
  const { panel_projects, token, user } = useSelector((state) => state.auth);
  const { studyId } = useSelector((state) => state.study);
  const url = new URL(window.location.href);
  const pidFromUrl = url.searchParams.get("pid");
  const finalStudyId = studyId || pidFromUrl;
  const [mode, setMode] = useState("");
  const [loading, setLoading] = useState(true); // loader state
  const [searchParams] = useSearchParams();
  const tid = searchParams.get("tid");
  const session_id = searchParams.get("session_id");
  const trigger_type = searchParams.get("trigger_type");
  const location = useLocation();
  const hostname = window.location.hostname;
  const match = location.pathname.match(/fromClient-(\d+)/);
  const clientId = match ? match[1] : null;

  useEffect(() => {
    if (window.location.pathname.includes("create")) {
      setMode("add");
    } else if (window.location.pathname.includes("edit")) {
      setMode("edit");
    } else {
      setMode("clone");
    }
  }, []);

  return (
    <div
      className="container-fluid page-wrapper"
      style={{ position: "relative" }}
    >
      <div className="row">
        <div className="col-12">
          <div className="card shadow-card" style={{ minHeight: "590px" }}>
            <div className="d-flex justify-content-between align-items-center p-3">
              <h6 className="m-0 title fs-13">Create a Custom XMOT</h6>
            </div>
            <div
              style={{
                width: "100%",
                height: "600px",
                border: "1px solid #ccc",
                position: "relative",
              }}
            >
              {/* Loader overlay */}
              {loading && (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#fff",
                    zIndex: 10,
                  }}
                >
                  <div
                    className="spinner-border"
                    role="status"
                    style={{ color: "black" }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}

              <iframe
                src={`https://staging.qualsights.com/xmot/xmot-survey?id=${getClientIdFromUrl(hostname)}&pid=${finalStudyId}&tstring=${token}&xmot_client_id=${user?.type === "superadmin" ? clientId : user?.id}&mode=${mode}&tid=${tid}&session_id=${session_id}&user_type=${user?.type}&env=${window.location.origin}&trigger_type=${trigger_type}`}
                title="Third Party Content"
                width="100%"
                height="100%"
                style={{ border: "none" }}
                allowFullScreen
                onLoad={() => setLoading(false)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateSurveyFrame;
